import React, { useEffect, useMemo, useState } from "react";
import { Trait, TraitResult } from "./model";
import { Course, CourseList, courseToLink, loadCourses } from "./api";
import { Loading } from "../components/Loading";
import { reset } from "./store";

function CourseListRender({trait, type, courses}:{trait: string, type: string, courses: Course[]}){
    function open(course:Course){
       window.location.href = courseToLink(course)
    }

    return <div className="trait-course-list">
        <p>{type}</p>
        <ul>
            {courses.map(c => <li key={c.name} onClick={()=>open(c)}>{c.name}</li>)}
        </ul>
    </div>
}


const labels = {
    D: "Dominância", 
    I: "Influência",
    S: "eStabiliade",
    C: "Conformidade",
}

function textClass(trait: string){
    return `text-trait-${trait.toLowerCase()}`
}

function bgClass(trait: string){
    return `bg-trait-${trait.toLowerCase()}`
}

function ResultChart({result}:{result: Record<Trait, number>}){
    const max = useMemo(()=>{
        return Object.values(result).reduce((c, v) => Math.max(c, v), 0);
    }, [])
    const height = 50;
    function normalize(a:number){
        return Math.max((a || 0) / max * height, 4)
    }
    return <>
        <div className="trait-result-chart" style={{display: "flex", alignItems:"end", justifyContent:"center", gap: "8px"}} >
            <div className="bg-trait-d" style={{width: "16px", height: `${normalize(result['D'])}px`}}></div>
            <div className="bg-trait-i" style={{width: "16px", height: `${normalize(result['I'])}px`}}></div>
            <div className="bg-trait-s" style={{width: "16px", height: `${normalize(result['S'])}px`}}></div>
            <div className="bg-trait-c" style={{width: "16px", height: `${normalize(result['C'])}px`}}></div>
        </div>
        <div className="trait-result-legend" style={{display: "flex", alignItems:"end", justifyContent:"center", gap: "8px"}} >
            <div className="text-trait-d text-center" style={{width: "16px"}}>D</div>
            <div className="text-trait-i text-center" style={{width: "16px"}}>I</div>
            <div className="text-trait-s text-center" style={{width: "16px"}}>S</div>
            <div className="text-trait-c text-center" style={{width: "16px"}}>C</div>
        </div>
    </>
}

export function ResultView({result}:{result:TraitResult}){
    const [courses, setCourses] = useState<CourseList>();

    useEffect(() =>{
        (async function (){
            setCourses(await loadCourses())
        })()
    }, [])

    
    if(courses == null)
        return <Loading />

    return <div className="trait-final-result">
        <h2>Obrigado!</h2>
        <h4>Você completou o teste.</h4>

        <ResultChart result={result.result} />
        
        <p>Um e-mail foi enviado para você com o resultado a seguir.</p>
        
        <p>De acordo com as respostas você tem a carecteristica 
            {" "}<b className={textClass(result.first)}>{labels[result.first]}</b> como primária 
        e a <b className={textClass(result.second)}>{labels[result.second]}</b> como secundária.</p>

        <CourseListRender type="Principais Cursos" trait={result.first} courses={courses.courses[result.first]} />
        <CourseListRender type="Veja também" trait={result.second} courses={courses.courses[result.second]} />

        <div className="text-center">
            <button className="btn btn-primary" onClick={reset} style={{marginTop: "3rem", width: "auto"}}><i className="fa fa-refresh" style={{color:"white", marginRight:"5px"}} ></i> Refazer Teste</button>
        </div>
    </div>

}